/**
 * Is this a phone-width viewport — the one the `@container console-app-shell
 * (max-width: 560px)` block in `styles.css` designs for?
 *
 * The layout itself is container queries, and deliberately so; this is not a
 * second copy of the breakpoint for styling. It exists because two panes have
 * to *open closed* at phone width, and "closed" is React state that has to be
 * seeded before the first paint. CSS can present state; it cannot decide it.
 *
 * A media query stands in for the container query, and the two agree because
 * `.console-app-shell` is `w-full` inside a body with no horizontal chrome —
 * its inline size is the viewport's. The one width where they could disagree is
 * the boundary itself, where the gutter is still in flow; a pane that opens on
 * the wrong side of 560px by one pixel is not a failure worth a ResizeObserver
 * and a frame of layout thrash to avoid.
 *
 * Read once, at mount, and never subscribed to. Rotating an iPhone to landscape
 * crosses this line, and the pane deliberately does not slam shut when it does:
 * that would throw away a tree the reader had just opened. The container query
 * still re-lays-out on rotation, which is the part that matters.
 */
export const PHONE_MAX_WIDTH = 560;

export function isPhoneViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(`(max-width: ${PHONE_MAX_WIDTH}px)`).matches;
}
